import axios from '@/user/axios.js'

const moduleUser = {
  namespaced: true,
  state: {
    users: []
  },
  mutations: {
    SET_USERS (state, payload) {
      state.users = payload
    }
  },
  actions: {
    listUsers (context) {
      const accountId = context.rootState.account.activeAccount.id
      return new Promise((resolve, reject) => {
        axios.get(`/api/users/${accountId}`)
          .then(resp => {
            if (resp.data.success) {
              context.commit('SET_USERS', resp.data.data)
              resolve(resp)
            }
          }).catch(err => {
            reject(err)
          })
      })
    },
    addUser (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post('/api/users/', payload)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    deleteUser (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { id } = payload
          const res = await axios.delete(`/api/users/${id}`)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    updateUser (context, payload) {
      return new Promise(async (resolve, reject) => {
        const { id, password, password_confirm, ...others } = payload
        let data = others
        if (password) {
          data = {
            ...others,
            password,
            password_confirm
          }
        }
        try {
          const res = await axios.put(`/api/users/${id}`, data)
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    }
  }
}

export default moduleUser
